import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7 4h15.5A1.5 1.5 0 0 1 24 5.5v19a1.5 1.5 0 0 1-1.5 1.5H7zM10.5 4v22" }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "M15.5 4v7l2-1.5 2 1.5V4" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }